"use client";
// import { createCache, extractStyle, StyleProvider } from "@ant-design/cssinjs";
import { usePathname } from "next/navigation";
import type { Session } from "next-auth";
import { SessionProvider as NextSessionProvider, signOut, useSession } from "next-auth/react";
import type { ReactNode } from "react";
import { useEffect, useRef } from "react";

const PUBLIC_PATHNAME_PREFIXES = ["/login"];

const SessionUpdater = () => {
  const { data: session, status } = useSession();
  const signingOut = useRef(false);
  const pathname = usePathname();
  useEffect(() => {
    const refreshFailed = session?.error === "RefreshAccessTokenError";
    if (refreshFailed || status === "unauthenticated") {
      let is_public_page = false;
      PUBLIC_PATHNAME_PREFIXES.forEach(function (element) {
        // Check if the first word is prefix
        if (pathname.indexOf(element) == 0) {
          is_public_page = true;
        }
      });

      if (!is_public_page && !signingOut.current) {
        signingOut.current = true;
        void signOut({ callbackUrl: "/login?sex" });
      }
    }
  }, [pathname, session, status]);

  return <></>;
};

export const SessionProvider = ({ children, session }: { children: ReactNode; session: Session | null }) => {
  // console.log(other);
  // const session = await auth()
  // if (session?.user) {
  //     session.user = {
  //       name: session.user.username,
  //       email: session.user.email,
  //       isAdmin: session.user.isAdmin,
  //     }
  //   }

  // return <ThemeProvider attribute="class">{children}</ThemeProvider>;
  return (
    <NextSessionProvider refetchInterval={60 * 1} session={session}>
      <SessionUpdater />
      {children}
    </NextSessionProvider>
  );
};
